import Keycloak from "keycloak-js";

let keycloakInstance;

export const createKeycloak = () => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      url:
        process.env.REACT_APP_KEYCLOAK_URL ||
        process.env.VITE_KEYCLOAK_URL ||
        "https://auth-amse.cap-tropicalia.cust.app.br",
      realm: process.env.REACT_APP_KEYCLOAK_REALM || process.env.VITE_KEYCLOAK_REALM || "tropicalica",
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || process.env.VITE_KEYCLOAK_CLIENT_ID || "app-tropicalia-dev",
    });
  }
  return keycloakInstance;
};
